import React, { useEffect, useRef, useState } from "react";
import { Delete } from "lucide-react";

import { calcular, numero } from "../lib/numeros";

const TECLAS = [
  ["C", "(", ")", "÷"],
  ["7", "8", "9", "×"],
  ["4", "5", "6", "−"],
  ["1", "2", "3", "+"],
  ["0", ",", "⌫", "="],
];
const OPERADOR = { "÷": "/", "×": "*", "−": "-", "+": "+" };
const DO_TECLADO = { "/": "÷", "*": "×", x: "×", "-": "−", "+": "+", ".": ",", ",": ",", "(": "(", ")": ")" };

// Calculadora de bolso: faz a conta e manda o resultado para o campo.
export default function Calculadora({ inicial, casas = 2, aoUsar }) {
  const [expr, setExpr] = useState(inicial ? numero(inicial, casas, { minimo: 0 }).replace(/\./g, "") : "");
  const caixa = useRef(null);
  const resultado = calcular(expr.replace(/÷/g, "/").replace(/×/g, "*").replace(/−/g, "-"));

  useEffect(() => { caixa.current?.focus(); }, []);

  const tocar = (t) => {
    if (t === "C") return setExpr("");
    if (t === "⌫") return setExpr((e) => e.slice(0, -1));
    if (t === "=") return resultado != null && setExpr(numero(resultado, 4, { minimo: 0 }).replace(/\./g, ""));
    setExpr((e) => e + t);
  };

  const teclado = (e) => {
    const k = e.key;
    if (/^\d$/.test(k)) tocar(k);
    else if (DO_TECLADO[k]) tocar(DO_TECLADO[k]);
    else if (k === "Backspace") tocar("⌫");
    else if (k === "Enter") { if (resultado != null) aoUsar(resultado); }
    else if (k.toLowerCase() === "c" || k === "Delete") tocar("C");
    else return;
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div ref={caixa} tabIndex={-1} onKeyDown={teclado} className="w-64 outline-none" data-e2e="calculadora">
      <div className="rounded-lg bg-muted/60 px-3 py-2 text-right mb-2">
        <div className="text-xs text-muted-foreground min-h-[1rem] break-all font-mono">{expr || " "}</div>
        <div className="text-2xl font-bold tabular-nums">{resultado != null ? numero(resultado, 4, { minimo: 0 }) : "0"}</div>
      </div>
      <div className="grid grid-cols-4 gap-1.5">
        {TECLAS.flat().map((t) => (
          <button key={t} type="button" onClick={() => tocar(t)}
            className={`h-10 rounded-md text-base font-semibold transition-colors active:scale-95 ${
              t === "=" ? "bg-primary text-primary-foreground hover:bg-primary/90"
                : OPERADOR[t] || t === "C" || t === "(" || t === ")" ? "bg-muted text-foreground hover:bg-muted/70"
                  : "bg-card border hover:bg-muted/50"}`}>
            {t === "⌫" ? <Delete className="w-4 h-4 mx-auto" /> : t}
          </button>
        ))}
      </div>
      <button type="button" disabled={resultado == null} onClick={() => aoUsar(resultado)}
        className="mt-2 w-full h-10 rounded-md bg-emerald-600 text-white font-semibold hover:bg-emerald-700 disabled:opacity-40">
        Usar {resultado != null ? numero(resultado, casas, { minimo: casas === 2 ? 2 : 0 }) : "resultado"}
      </button>
    </div>
  );
}
